export default function useProxyUrl() {
  return process.env.REACT_APP_PROXY_SERVER ?? '';
}
